export const DEFAULT_LANGUAGE = 'tr'
export const FALLBACK_LANGUAGE = 'tr'
export const SUPPORTED_LANGUAGES = ['tr', 'en','de']